export default {
  props: {
    size: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    sizeClass() {
      return { [`form-control-${this.size}`]: this.size };
    },
  },
};
